import { Injectable } from "@angular/core";
import { IIndicatorDataStrategy, IIndicatorData } from "../../models/domains/pbm/indicators/iindicator-data-strategy";
import { UserService } from "../user.service";
import { IndicatorService } from "./indicator.service";

@Injectable({ providedIn: "root" })
export class IndicatorMediator {
  constructor(private indicatorService: IndicatorService, private userService: UserService) {}

  async getIndicatorData(indicatorDataStrategy: IIndicatorDataStrategy): Promise<IIndicatorData> {
    return await indicatorDataStrategy.processData(this.indicatorService, this.userService);
  }
}
